import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ThankyouPage.module.css";
import TextLink from "../TextLink";
import useLeadsRX from "../../lib/useLeadsRX";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";

const strings = {
    title: "1st Financial Bank USA Card Request Completed",
    header: "Thank you for your application",
    p1: "We are unable at this time to complete the processing of your online application.",
    p2:
        "Once we have completed the processing of your application, we will notify you in writing" +
        " at the address listed on your application of the action taken on that application.",
    p3Start: "If you have any questions, just call us at ",
    p3Phone: "1-800-733-1732",
    p3End:
        ", Monday through Friday, 8:00 am to 8:00 pm CT and Saturday 8:00 am to 5:00 pm CT excluding Federal holidays.",
};

const LRX_CODE = 14397;

export default function ThankyouPage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);
    useLeadsRX(LRX_CODE);

    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.header}</h1>
                    </Column>
                </Row>
                <Row className={styles.p1Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p1}</div>
                    </Column>
                </Row>
                <Row className={styles.p2Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p2}</div>
                    </Column>
                </Row>
                <Row className={styles.p3Row}>
                    <Column>
                        <div className={styles.paragraph}>
                            {strings.p3Start}{" "}
                            <TextLink
                                openInSameTab={true}
                                className={styles.link}
                                href="tel:800-733-1732"
                                text={strings.p3Phone}
                            />
                            {strings.p3End}
                        </div>
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
